/**
 *
 * ParrotSoftware
 * PaymentsGatewayProvider root
 *
 */
import { Children, memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function PaymentsGatewayProvider({ children }) {
  useInjectSaga({ key: 'paymentsGatewayProvider', saga });
  useInjectReducer({ key: 'paymentsGatewayProvider', reducer });

  return Children.only(children);
}

PaymentsGatewayProvider.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withPaymentsGateway } from './withPaymentsGateway';
export default compose(withConnect, memo)(PaymentsGatewayProvider);
